import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getAccountDashboardUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const UIAccountSummaryButton = props => {
  const {
    trackingSource,
    use,
    'data-selenium-id': dataSeleniumId,
    block,
    size,
    truncate = true
  } = props;
  const handleClick = () => {
    tracker.track('externalLinkClick', {
      name: 'account-summary',
      trackingSource
    });
  };
  return /*#__PURE__*/_jsx(UIButton, {
    href: getAccountDashboardUrl(),
    onClick: handleClick,
    target: "_blank",
    truncate: truncate,
    use: use,
    "data-selenium-id": dataSeleniumId,
    block: block,
    size: size,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.viewAccountButton.text"
    })
  });
};
export default UIAccountSummaryButton;